import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/a34b1e0ab002dc04c0156491411f9278.jpeg"
              alt="King Square Club"
              className="h-16 w-16 object-contain"
            />
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className="text-white hover:text-amber-400 transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Home
            </Link>
            <Link
              to="/events"
              className="text-white hover:text-amber-400 transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Events
            </Link>
            <Link
              to="/gallery"
              className="text-white hover:text-amber-400 transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Gallery
            </Link>
            <Link
              to="/about"
              className="text-white hover:text-amber-400 transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              About
            </Link>
            <Link
              to="/contact"
              className="text-white hover:text-amber-400 transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Contact
            </Link>
            <Link
              to="/contact"
              className="bg-amber-500 hover:bg-amber-600 text-black px-6 py-2 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Book Reservation
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-4">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-white hover:text-amber-400 transition-colors duration-300 text-sm font-medium cursor-pointer"
            >
              Home
            </Link>
            <Link
              to="/events"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-white hover:text-amber-400 transition-colors duration-300 text-sm font-medium cursor-pointer"
            >
              Events
            </Link>
            <Link
              to="/gallery"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-white hover:text-amber-400 transition-colors duration-300 text-sm font-medium cursor-pointer"
            >
              Gallery
            </Link>
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-white hover:text-amber-400 transition-colors duration-300 text-sm font-medium cursor-pointer"
            >
              About
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-white hover:text-amber-400 transition-colors duration-300 text-sm font-medium cursor-pointer"
            >
              Contact
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="bg-amber-500 hover:bg-amber-600 text-black px-6 py-2 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer inline-block"
            >
              Book Reservation
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}